module.exports = __webpack_public_path__ + "media/images/common/container_bg-8fe0f8fdab888d0878aa776357935223.gif";